/* ==========================================================================
   FxAlchemist — theme behaviour
   Replaces the Elementor / JetElements JS of the original site:
   accordion, animated counters, countdown, coupon popup,
   testimonial slider, mobile nav.
   ========================================================================== */
(function () {
  'use strict';

  var onReady = function (fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  };

  /* ------------------------------------------------------------ accordion */
  function initAccordion(root) {
    root.querySelectorAll('[data-accordion-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-accordion-item]');
        var panel = item.querySelector('[data-accordion-panel]');
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '';
      });
    });

    // Keep an open panel correctly sized when the viewport changes.
    window.addEventListener('resize', function () {
      root.querySelectorAll('[data-accordion-item].is-open [data-accordion-panel]')
        .forEach(function (p) { p.style.maxHeight = p.scrollHeight + 'px'; });
    });
  }

  /* ------------------------------------------------------- number counters */
  function runCounter(el) {
    if (el.dataset.counted) return;
    el.dataset.counted = '1';

    var target = parseFloat(el.dataset.counterTo || '0');
    var decimals = parseInt(el.dataset.counterDecimals || '0', 10);
    var duration = parseInt(el.dataset.counterDuration || '2000', 10);
    var start = null;

    /* Trennzeichen kommt aus dem Theme, nicht aus der Browsersprache.
       Das Original benutzt Elementors Zähler, der nach Spracheinstellung
       formatiert — dort steht bei deutschen Besuchern ein Komma, bei
       englischen ein Punkt. Fest eingestellt sehen alle dasselbe. */
    var separator = el.dataset.counterSeparator || '.';

    function formatiere(wert) {
      var s = wert.toFixed(decimals);
      return separator === '.' ? s : s.replace('.', separator);
    }

    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      // easeOutExpo — matches the Elementor counter feel
      var eased = p === 1 ? 1 : 1 - Math.pow(2, -10 * p);
      el.textContent = formatiere(target * eased);
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = formatiere(target);
    }
    requestAnimationFrame(step);
  }

  function initCounters() {
    var counters = document.querySelectorAll('[data-counter-to]');
    if (!counters.length) return;

    if (!('IntersectionObserver' in window)) {
      counters.forEach(runCounter);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { runCounter(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.4 });
    counters.forEach(function (c) { io.observe(c); });
  }

  /* -------------------------------------------------------------- reveal */
  /* Blendet die vier Blöcke ein, die das Original beim Hereinscrollen
     einblendet. Ohne IntersectionObserver bleibt alles sofort sichtbar. */
  function initReveal() {
    var items = document.querySelectorAll('.reveal');
    if (!items.length) return;

    var show = function (el) { el.classList.add('is-in'); };

    if (!('IntersectionObserver' in window)) {
      items.forEach(show);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { show(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------------------ countdown */
  function initCountdown() {
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      var endAttr = el.dataset.countdown;
      var end = Date.parse(endAttr);

      // No/invalid date configured -> evergreen 48h timer per visitor,
      // persisted so it does not restart on every page view.
      if (isNaN(end)) {
        var key = 'fxa_countdown_' + (el.dataset.countdownId || 'default');
        var stored = null;
        try { stored = localStorage.getItem(key); } catch (err) {}
        var hours = parseFloat(el.dataset.countdownHours || '48');
        if (stored && !isNaN(parseInt(stored, 10))) {
          end = parseInt(stored, 10);
        } else {
          end = Date.now() + hours * 3600 * 1000;
          try { localStorage.setItem(key, String(end)); } catch (err) {}
        }
        if (end < Date.now()) {
          end = Date.now() + hours * 3600 * 1000;
          try { localStorage.setItem(key, String(end)); } catch (err) {}
        }
      }

      var out = {
        days:    el.querySelector('[data-cd-days]'),
        hours:   el.querySelector('[data-cd-hours]'),
        minutes: el.querySelector('[data-cd-minutes]'),
        seconds: el.querySelector('[data-cd-seconds]')
      };

      function pad(n) { return (n < 10 ? '0' : '') + n; }

      function tick() {
        var diff = Math.max(0, end - Date.now());
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400);
        var h = Math.floor((s % 86400) / 3600);
        var m = Math.floor((s % 3600) / 60);
        var sec = s % 60;
        if (out.days)    out.days.textContent    = pad(d);
        if (out.hours)   out.hours.textContent   = pad(h);
        if (out.minutes) out.minutes.textContent = pad(m);
        if (out.seconds) out.seconds.textContent = pad(sec);
        if (diff <= 0) clearInterval(timer);
      }
      tick();
      var timer = setInterval(tick, 1000);
    });
  }

  /* ------------------------------------------------------------ mobile nav */
  function initNav() {
    document.querySelectorAll('[data-nav-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var nav = document.getElementById(btn.getAttribute('aria-controls'));
        if (!nav) return;
        var open = nav.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.body.style.overflow = open ? 'hidden' : '';
      });
    });
  }

  /* -------------------------------------------------------- coupon popup */
  function initCouponPopup() {
    var popup = document.querySelector('[data-coupon-popup]');
    if (!popup) return;

    // The section is re-rendered in the theme editor; without this guard every
    // re-init would attach another document-level listener to a stale element.
    if (popup.dataset.couponBound === '1') return;
    popup.dataset.couponBound = '1';

    var key = 'fxa_coupon_seen';
    var delay = parseInt(popup.dataset.delay || '15', 10) * 1000;
    var code = popup.dataset.code || '';

    // In the theme editor the popup should stay previewable, so the
    // "already seen" flag is ignored there.
    var inEditor = !!(window.Shopify && window.Shopify.designMode);

    var seen = false;
    try { seen = localStorage.getItem(key) === '1'; } catch (e) {}

    // "armed" = may still open by itself. It is cleared the moment the popup
    // opens or is dismissed, so neither the timer nor exit intent can bring it
    // back during this page view.
    var armed = inEditor || !seen;
    var timer = null;

    function onExitIntent(e) {
      if (!e.relatedTarget && e.clientY < 10) open();
    }

    function disarm() {
      armed = false;
      if (timer) { clearTimeout(timer); timer = null; }
      document.removeEventListener('mouseout', onExitIntent);
    }

    function open() {
      if (!armed) return;
      disarm();
      popup.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      try { localStorage.setItem(key, '1'); } catch (e) {}
    }

    function close() {
      popup.classList.remove('is-open');
      document.body.style.overflow = '';
      disarm();
    }

    if (armed) {
      timer = setTimeout(open, delay);
      document.addEventListener('mouseout', onExitIntent);
    }

    popup.querySelectorAll('[data-coupon-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    popup.addEventListener('click', function (e) { if (e.target === popup) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) close();
    });

    // Step 1 (email) -> step 2 (code)
    var form = popup.querySelector('[data-coupon-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        popup.querySelector('[data-coupon-step="1"]').hidden = true;
        popup.querySelector('[data-coupon-step="2"]').hidden = false;
      });
    }

    var copyBtn = popup.querySelector('[data-coupon-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var done = function () {
          var old = copyBtn.textContent;
          copyBtn.textContent = copyBtn.dataset.copiedLabel || 'Copied!';
          setTimeout(function () { copyBtn.textContent = old; }, 2000);
        };
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done);
        else done();
      });
    }
  }

  /* ---------------------------------------------------- testimonial slider */
  function initSliders() {
    document.querySelectorAll('[data-slider]').forEach(function (slider) {
      var track = slider.querySelector('[data-slider-track]');
      if (!track) return;
      if (track.dataset.sliderBound === '1') return;
      track.dataset.sliderBound = '1';

      var prev = slider.querySelector('[data-slider-prev]');
      var next = slider.querySelector('[data-slider-next]');

      /* Endlosschleife: Die Kacheln werden einmal dupliziert. Läuft der
         Bildlauf über die Hälfte hinaus, springt er lautlos um genau diese
         Hälfte zurück — für das Auge läuft es endlos weiter. */
      var loop = track.hasAttribute('data-slider-loop');
      if (loop && track.children.length) {
        var original = Array.prototype.slice.call(track.children);
        original.forEach(function (kachel) {
          var kopie = kachel.cloneNode(true);
          kopie.setAttribute('aria-hidden', 'true');
          kopie.querySelectorAll('a').forEach(function (a) { a.tabIndex = -1; });
          track.appendChild(kopie);
        });
      }

      function schritt() {
        var first = track.firstElementChild;
        if (!first) return 320;
        var gap = parseFloat(getComputedStyle(track).columnGap || '0');
        return first.getBoundingClientRect().width + gap;
      }

      function haelfte() {
        return loop ? track.scrollWidth / 2 : Infinity;
      }

      function weiter(richtung) {
        if (loop) {
          if (richtung > 0 && track.scrollLeft >= haelfte() - schritt() / 2) {
            track.scrollLeft -= haelfte();
          } else if (richtung < 0 && track.scrollLeft <= 0) {
            track.scrollLeft += haelfte();
          }
        }
        track.scrollBy({ left: richtung * schritt(), behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { anhalten(); weiter(-1); });
      if (next) next.addEventListener('click', function () { anhalten(); weiter(1); });

      /* Autoplay — Pause bei Mauskontakt und nach eigener Bedienung,
         genau wie im Original (pause_on_hover, pause_on_interaction). */
      var takt = parseInt(track.dataset.sliderAutoplay || '0', 10);
      var timer = null;

      function starten() {
        if (!takt || timer) return;
        timer = setInterval(function () { weiter(1); }, takt);
      }
      function pausieren() {
        if (timer) { clearInterval(timer); timer = null; }
      }
      function anhalten() {
        pausieren();
        takt = 0;
      }

      if (takt) {
        slider.addEventListener('mouseenter', pausieren);
        slider.addEventListener('mouseleave', starten);
        track.addEventListener('touchstart', anhalten, { passive: true });
        starten();
      }
    });
  }

  /* --------------------------------------------------------- announcement */
  function initAnnouncement() {
    var bar = document.querySelector('[data-announcement]');
    var spacer = document.querySelector('[data-announcement-spacer]');

    // The bar is position:fixed, so the spacer has to reserve its height.
    // Die Höhe wird zusätzlich als CSS-Variable hinterlegt: Sprungziele wie
    // #plans müssen um genau diesen Betrag tiefer anhalten, sonst verschwindet
    // die Überschrift unter dem Banner.
    function syncSpacer() {
      if (!bar || !spacer) return;
      var top = parseFloat(getComputedStyle(bar).top) || 0;
      var hoehe = bar.getBoundingClientRect().height + top;
      spacer.style.height = hoehe + 'px';
      document.documentElement.style.setProperty('--announce-h', hoehe + 'px');
    }
    syncSpacer();
    window.addEventListener('resize', syncSpacer);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncSpacer);

    document.querySelectorAll('[data-announcement-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (bar) bar.remove();
        if (spacer) spacer.remove();
        document.documentElement.style.setProperty('--announce-h', '0px');
      });
    });
  }

  /* ------------------------------------------------------- Sprungmarken */
  /* Eigene Bildlauf-Animation statt scrollTo({behavior:'smooth'}).
     Grund: Der weiche Bildlauf des Browsers wird hier zwar entgegengenommen,
     aber nicht ausgeführt — der Klick liefe ins Leere. window.scrollTo(x, y)
     ohne Optionen arbeitet dagegen zuverlässig, also wird die Bewegung Bild
     für Bild selbst gerechnet. */
  function sanftScrollen(zielY) {
    var start = window.pageYOffset;
    if (Math.abs(zielY - start) < 2) return;

    // Zuerst der eingebaute weiche Bildlauf — in normalen Browsern genau das,
    // was man will, inklusive Rücksicht auf prefers-reduced-motion.
    try {
      window.scrollTo({ top: zielY, behavior: 'smooth' });
    } catch (e) {
      window.scrollTo(0, zielY);
      return;
    }

    /* Notnagel: Manche Umgebungen nehmen den weichen Bildlauf entgegen, führen
       ihn aber nie aus — der Klick liefe dann ins Leere. Hat sich nach 350ms
       nichts bewegt, wird hart gesprungen. Dafür muss scroll-behavior kurz auf
       auto stehen, sonst wird auch der harte Sprung wieder weich gedeutet und
       ebenso verschluckt. */
    setTimeout(function () {
      if (Math.abs(window.pageYOffset - start) >= 2) return;
      var wurzel = document.documentElement;
      var vorher = wurzel.style.scrollBehavior;
      wurzel.style.scrollBehavior = 'auto';
      window.scrollTo(0, zielY);
      wurzel.style.scrollBehavior = vorher;
    }, 350);
  }

  /* Klicks auf #plans & Co. selbst ausführen statt dem Browser zu überlassen.
     Zwei Gründe: Der feste Banner verdeckt sonst das Ziel, und body hat
     overflow-x:hidden — dadurch ist der Body die Bildlauffläche, was den
     eingebauten Ankersprung je nach Browser aushebelt. */
  function initAnchors() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href*="#"]');
      if (!link) return;

      var href = link.getAttribute('href') || '';
      var raute = href.indexOf('#');
      if (raute < 0) return;

      var id = href.slice(raute + 1);
      if (!id) return;

      // Nur seiteninterne Links: Pfad davor muss leer oder der aktuelle sein.
      var pfad = href.slice(0, raute);
      if (pfad && pfad !== location.pathname && pfad !== location.pathname + location.search) return;

      var ziel = document.getElementById(id);
      if (!ziel) return;

      e.preventDefault();

      var abstand = parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue('--announce-h')
      ) || 0;

      var y = Math.max(0, ziel.getBoundingClientRect().top + window.pageYOffset - abstand);
      sanftScrollen(y);

      if (history.replaceState) history.replaceState(null, '', '#' + id);
    });
  }

  /* ------------------------------------------- schwebender Kontaktknopf */
  /* Öffnet und schließt die Kanalliste. Schließt außerdem bei Klick daneben
     und mit Escape — ein Menü, das nur über denselben Knopf wieder zugeht,
     fühlt sich auf dem Handy wie eine Falle an. */
  function initChat() {
    var chat = document.querySelector('[data-chat]');
    if (!chat || chat.dataset.bound === '1') return;
    chat.dataset.bound = '1';

    var knopf = chat.querySelector('[data-chat-toggle]');
    var liste = chat.querySelector('[data-chat-list]');
    if (!knopf || !liste) return;

    function setzen(offen) {
      chat.classList.toggle('is-open', offen);
      knopf.setAttribute('aria-expanded', offen ? 'true' : 'false');
      liste.hidden = !offen;
    }

    knopf.addEventListener('click', function (e) {
      e.stopPropagation();
      setzen(liste.hidden);
    });

    document.addEventListener('click', function (e) {
      if (!chat.contains(e.target)) setzen(false);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setzen(false);
    });
  }

  /* ------------------------------------------ Verteiler zu den Tutorials */
  /* Folgt der Logik des Originals: Der Wert des Landes ist bereits der
     Broker-Code, dazu kommt das Betriebssystem. Im Original hiess der Code
     fuer PU Prime aus historischen Gruenden "be" und wurde erst beim Bauen
     der Adresse zu "pu" — hier steht direkt "pu" im Auswahlfeld. */
  function initRouter() {
    var box = document.querySelector('[data-router]');
    if (!box || box.dataset.bound === '1') return;
    box.dataset.bound = '1';

    var land = box.querySelector('[data-router-country]');
    var os = box.querySelector('[data-router-os]');
    var knopf = box.querySelector('[data-router-go]');
    var fehler = box.querySelector('[data-router-error]');
    if (!land || !os || !knopf) return;

    var muster = box.getAttribute('data-router-pattern') || '/pages/en-{broker}-{os}';

    knopf.addEventListener('click', function () {
      if (!land.value || !os.value) {
        if (fehler) fehler.hidden = false;
        return;
      }
      if (fehler) fehler.hidden = true;
      window.location.href = muster
        .replace('{broker}', land.value)
        .replace('{os}', os.value);
    });

    [land, os].forEach(function (f) {
      f.addEventListener('change', function () {
        if (fehler && land.value && os.value) fehler.hidden = true;
      });
    });
  }

  onReady(function () {
    initAccordion(document);
    initCounters();
    initReveal();
    initCountdown();
    initNav();
    initCouponPopup();
    initSliders();
    initAnnouncement();
    initAnchors();
    initChat();
    initRouter();
  });

  // Shopify theme editor: re-init a section after it is re-rendered.
  document.addEventListener('shopify:section:load', function (e) {
    initAccordion(e.target);
    initCounters();
    initReveal();
    initCountdown();
    initNav();
    initCouponPopup();
    initSliders();
    initAnnouncement();
  });
})();
